import React from 'react';
import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;

const DateRangePickerComponent = ({ fromDate, toDate, onDateChange }) => {
    const value = fromDate && toDate ? [fromDate, toDate] : [];

    return (
        <RangePicker
            value={value}
            onChange={onDateChange}
            format="YYYY-MM-DD"
            allowClear
        />
    );
};

export default DateRangePickerComponent;
